import React, { useState } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { ReactNode } from 'react-markdown';
import { AppState, useAppSelector } from '../../../../RootReducer';
import { t } from '../../../../i18n';



interface CashbackButtonProps {
    amount: number;
    currencyCode: string;
}
/**
 * Cashback button for displaying cashback amount or message of no amount ( toggle functionality )
 * @returns 
 */
export default function CashbackButton(props: CashbackButtonProps): React.ReactElement {
    const [showAmount, setshowAmount] = useState<boolean>(false);
    const currencies = useAppSelector((app: AppState) => app.settings.settings?.currencies);
    const hasAmount = props.amount > 0;

    const showAmountWhenClicked = () => hasAmount && setshowAmount((p) => !p)

    const formatAmount = (): string => {
        const currencyDefinition = currencies?.find((c) => c.code === props.currencyCode);
        const amount = typeof props.amount === 'string' ? parseFloat(props.amount) : props.amount;

        if (currencyDefinition) {
            const { fractionalDigits, prefixSymbol, postfixSymbol } = currencyDefinition;
            const symbol = prefixSymbol ?? postfixSymbol ?? "";
            return `${amount.toFixed(fractionalDigits)} ${symbol}`;
        }

        return `${amount.toFixed(2)}`;
    };

    return (
        <button onClick={showAmountWhenClicked} className={`btn cashback-btn ${showAmount ? "display-amount" : "hide-amount"} ${hasAmount ? "enabled" : "disabled"}`}>
            {buttonContent({ formatedAmount: formatAmount(), hasAmount, showAmount })}
        </button>
    )
}



interface ButtonContentProps {
    formatedAmount: string;
    hasAmount: boolean;
    showAmount: boolean;
}


/**
 * 
 * @returns 
 */
const buttonContent = ({ formatedAmount, hasAmount, showAmount }: ButtonContentProps) => {
    if (hasAmount && showAmount) {
        return (
            <div className="amount-info">
                {formatedAmount}*
                <TooltipWrapper>
                    <InfoSvg />
                </TooltipWrapper>
            </div>
        )
    }
    if (hasAmount && !showAmount) {
        return t("cashback.cashbackButton.showAmount");
    }
    if (!hasAmount) {
        return t("cashback.cashbackButton.noAmount");
    }
}


/**
 * Tooltip wrapper for cashback component ( could be used in other places )
 * @returns ToolTip
 */
const TooltipWrapper = ({ children }: { children: ReactNode | ReactNode[] }) => {
    return (
        <OverlayTrigger
            trigger={["hover", "focus"]}
            overlay={
                <Tooltip className="cashback-popup" placement="top" id="popover-trigger-hover-focus" title="Popover top">
                    {t("cashback.cashbackTooltipOne")} <br /> {t("cashback.cashbackTooltipTwo")}
                </Tooltip>
            }
        >
            {children as JSX.Element}
        </OverlayTrigger>
    );
};


/**
 * Info SVG only used in cashback component ( could be used in other places )
 * @returns SVG
 */
export const InfoSvg = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="#e8eaed">
            <path d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
        </svg>
    )
}

